/**
 * # formatDecimalPoints
 *
 * A function that formats a given floating point number to the specified floating point.
 *
 * ## Examples
 * __The function defaults to 2 decimal places__
 * ```
 * formatDecimalPoints(12.1234) => 12.12
 * ```
 *
 * __You can set your own decimal value by passing it in as the second param__
 * ```
 * formatDecimalPoints(12.1234, 0) => 12
 * formatDecimalPoints(12.1234, 4) => 12.1234
 * ```
 *
 * @param {number} value The number to format
 * @param {number} decimalPoints The number of decimal points to format the number to
 * @returns {number} formatted floating point number or integer
 */
const formatDecimalPoints = (value: number, decimalPoints?: number): number => {
  // The default decimal points is 2
  if (decimalPoints === undefined) decimalPoints = 2;

  const pow = Math.pow(10, decimalPoints);
  return Math.floor(value * pow) / pow;
};

export default formatDecimalPoints;
